export default __webpack_public_path__ + "static/media/MARCsymbolW.d13d2a17.png";